import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';

import { isMobileApp } from '../../utils/site';
// Just cloning for now to avoid issues
// after doing some refactoring based on latest mockups
// and then we can reuse the same Header component if that is possible
import './UserRegistrationHeader.css';
import PrimaryBlueButton from '../common/buttons/PrimaryBlueButton';
import BorderedButton from '../common/buttons/BorderedButton';
import { AUTHENTICATED } from '../../constants/user';
import MainLogo from './MainLogo';

const UserRegistrationHeader = () => {
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  if (isMobileApp) return;

  const renderMenuElements = () => {
    if (authStatus === AUTHENTICATED) return;

    return (
      <Grid item xs={8}>
        <Grid item container spacing={{ xs: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 12 }} justifyContent="flex-end">
          <Grid item xs={2} sm={3} md={4} sx={{ textAlign: 'right', marginRight: { xs: '30px', sm: '0px' } }}>
            <PrimaryBlueButton
              onClick={() => navigate('/login')}
              buttonText="Sign In"
              sxProps={{
                height: { md: 45, xs: 46, sm: 46 },
                width: { md: 158, xs: 90, sm: 100 },
                fontSize: '0.875rem',
                padding: { md: '8px 24px', xs: '2px 6px' },
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid key="grid-header" container spacing={1} id="user-registration-header-container">
      <MainLogo />
      {renderMenuElements()}
    </Grid>
  );
};

export default UserRegistrationHeader;
